import osName from './osName';
const isIOS = osName === 'iOS';
export default isIOS;